// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bvmakdxmlhwxovyhuwko.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ2bWFrZHhtbGh3eG92eWh1d2tvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkxNTMyMzcsImV4cCI6MjA1NDcyOTIzN30.ypoFw99xwFNbxccaYbCEgTBP_yfctk9OarOmcUvkU3o";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);